<template>
  <div class="resultaten-start">
    <subNav :methodes="methodes" :subnavstep="subnavstep"></subNav>

    <div class="introtext">
      <h2 class="introtext__title">Uw resultaat</h2>
      <ul>
        <li>Overzicht van de gekozen methodes</li>
        <li>Je kunt nog tips verwijderen</li>
        <li>Maak jouw eigen PDF</li>
        <li>Deel of print jouw PDF</li>
      </ul>
    </div>

    <div class="questiongroup">
      <button class="button button--wide" @click="onStep3Clicked">
        Stap 3: Uw resultaat
      </button>
    </div>

    <router-link
      :to="{ name: 'methodes', params: { doelSlug: slug } }"
      class="add-button"
    >
      <span class="label">Ik wil nog meer methodes toevoegen</span>
      <span class="icon-plus"></span>
    </router-link>
  </div>
</template>

<script>
import subNav from "../components/subNav.vue";

const ENDPOINT_NAME = "ppw/v1/methodnames";
const axios = require("axios");

export default {
  name: "tussenschermResultaat",

  data() {
    return {
      isLoading: true,
      isEmptyResult: false,
      methodes: "",
      storedMethods: [],
      count: 0,
      pushers: [],
      slug: "",
      subnavstep: "methodes",
    };
  },

  components: {
    subNav,
  },

  computed: {},

  methods: {
    getMethodeArray() {
      this.storedMethods = JSON.parse(localStorage.getItem("comparedItems"));
      const url = new URL(
        process.env.VUE_APP_REST_URL +
          ENDPOINT_NAME +
          "?methodes=" +
          this.storedMethods[0].methods
      );
      axios
        .get(url)
        .then((r) => {
          const results = r.data;
          if (!results) {
            this.methodes = "methodes niet bekend";
          } else {
            this.methodes = r.data.names;
          }
        })
        .catch((error) => {
          console.warn(error);
        });
    },
    onStep3Clicked() {
      _paq.push(["trackEvent", "userEvent", "resultOpened"]);
      this.$router.push({ name: 'eindResultaat', params: { doelSlug: this.slug }, });
    },
  },

  created() {
    this.slug = this.$route.params.doelSlug;
  },

  mounted() {
    this.getMethodeArray();
  },
};
</script>

